import { render, staticRenderFns } from "./CompartilharProntuario.vue?vue&type=template&id=1d0b364c&scoped=true"
import script from "./CompartilharProntuario.vue?vue&type=script&lang=ts"
export * from "./CompartilharProntuario.vue?vue&type=script&lang=ts"
import style0 from "./CompartilharProntuario.vue?vue&type=style&index=0&id=1d0b364c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0b364c",
  null
  
)

export default component.exports